module.exports = __webpack_public_path__ + "media/images/logo-prepaid-01d482b1d5bfb2f6cde2ef497c3f7ab5.svg";